function GetSourceTypeMapping () {
	const params = Array.prototype.slice.call(arguments);
	const mapList = params.map((param, index) => ([index + 1, param]));
	return new Map(mapList);
}
export default GetSourceTypeMapping;
